import PropTypes from "prop-types"
import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { FacebookProvider, ShareButton  } from 'react-facebook';
import bootstrap from "./bootstrap.module.css"

const Share = ({ url, text }) => (
  
<div className={'meta-share'}>  
  <FacebookProvider appId="1317447385416669">
    <ShareButton href={url} className={bootstrap.btn+' btn bg-facebook '+bootstrap.btnSm}>
      <FontAwesomeIcon icon={faFacebookF} fixedWidth />
    </ShareButton>
  </FacebookProvider>
  <a href={"https://twitter.com/intent/tweet?text="+text+' '+url} rel="nofollow noreferrer" target="_blank" className={bootstrap.btn+' btn bg-twitter '+bootstrap.btnSm}>
    <FontAwesomeIcon icon={faTwitter} fixedWidth />
  </a>
  <a href={"https://www.linkedin.com/sharing/share-offsite/?url="+url} rel="nofollow noreferrer" target="_blank" className={bootstrap.btn+' btn bg-linkedin '+bootstrap.btnSm}>
    <FontAwesomeIcon icon={faLinkedinIn} fixedWidth />
  </a>
</div>

)

Share.propTypes = {
  url: PropTypes.string,
}

export default Share
